import { DatabaseId } from "@syla/shared/types/helpers/Id";
import { AccountLedgerTypesResponse } from "@syla/shared/types/responses/AccountLedgerTypesResponse";
import axios from "axios";

export async function getAccountLedgerTypes(
  accountId: DatabaseId,
): Promise<AccountLedgerTypesResponse> {
  const response = await axios.get<AccountLedgerTypesResponse>(
    `/accounts/${accountId}/transactions/ledger-types`,
  );
  return response.data;
}
